function IconCheck({ size = 48, color = '#fff', ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="24" cy="24" r="22" stroke={color} strokeWidth="3" fill="none" />
            <path
                d="M16 24.5L22 30.5L32 18.5"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default IconCheck; 